"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Minus = exports.Download = exports.Document = exports.Settings = exports.RightCaret = exports.DownCaret = exports.Users = exports.RightArrow = exports.LeftArrow = exports.Home = exports.Close = exports.Plus = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _palette = require("../../theme/palette");

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultColor = _palette2.default["blue"]["600"];

const createIconSvg = (iconName, render) => {
  class IconSvg extends _react2.default.Component {

    render() {
      let { color } = this.props;

      return render({
        color
      });
    }
  }

  IconSvg.propTypes = {
    color: _propTypes2.default.string
  };
  IconSvg.defaultProps = {
    color: defaultColor
  };
  IconSvg.displayName = iconName;

  return IconSvg;
};

const Plus = exports.Plus = createIconSvg("Plus", ({ color }) => _react2.default.createElement("path", {
  d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  fill: color
}));

const Close = exports.Close = createIconSvg("Close", ({ color }) => _react2.default.createElement("path", {
  d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z",
  fill: color
}));

const Home = exports.Home = createIconSvg("Home", ({ color }) => _react2.default.createElement("path", {
  d: "M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z",
  fill: color
}));

const LeftArrow = exports.LeftArrow = createIconSvg("LeftArrow", ({ color }) => _react2.default.createElement("path", {
  d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42-.39-.39-1.02-.39-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z",
  fill: color
}));

const RightArrow = exports.RightArrow = createIconSvg("RightArrow", ({ color }) => _react2.default.createElement("path", {
  d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z",
  fill: color
}));

const Users = exports.Users = createIconSvg("Users", ({ color }) => _react2.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z",
  fill: color
}));

const DownCaret = exports.DownCaret = createIconSvg("DownCaret", ({ color }) => _react2.default.createElement("path", {
  d: "M17.3,10c-0.4-0.4-1-0.4-1.4,0L12,13.9L8.1,10c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l4.6,4.6c0.4,0.4,1,0.4,1.4,0 l4.6-4.6C17.7,11,17.7,10.4,17.3,10z",
  fill: color
}));

const RightCaret = exports.RightCaret = createIconSvg("RightCaret", ({ color }) => _react2.default.createElement("path", {
  d: "M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z",
  fill: color
}));

const Settings = exports.Settings = createIconSvg("Settings", ({ color }) => _react2.default.createElement("path", {
  d: "M16.6,13.9c0.4,0,0.6,0.3,0.6,0.6v1.7c0,0.4-0.3,0.6-0.6,0.6h-0.6c-0.1,0.4-0.3,0.9-0.5,1.3 l0.4,0.4c0.3,0.3,0.3,0.7,0,0.9l-1.2,1.2c-0.3,0.3-0.7,0.3-0.9,0l-0.4-0.4c-0.4,0.2-0.8,0.4-1.3,0.5v0.6c0,0.4-0.3,0.6-0.6,0.6H9.7 c-0.4,0-0.6-0.3-0.6-0.6v-0.6c-0.4-0.1-0.9-0.3-1.3-0.5l-0.4,0.4c-0.3,0.3-0.7,0.3-0.9,0l-1.2-1.2c-0.3-0.3-0.3-0.7,0-0.9l0.4-0.4 c-0.2-0.4-0.4-0.8-0.5-1.3H4.5c-0.4,0-0.6-0.3-0.6-0.6v-1.7c0-0.4,0.3-0.6,0.6-0.6h0.6c0.1-0.4,0.3-0.9,0.5-1.3l-0.4-0.4 c-0.3-0.3-0.3-0.7,0-0.9L6.4,10c0.3-0.3,0.7-0.3,0.9,0l0.4,0.4c0.4-0.2,0.8-0.4,1.3-0.5l0-0.6c0-0.4,0.3-0.6,0.6-0.6h1.7 C11.8,8.7,12,9,12,9.3V10c0.4,0.1,0.9,0.3,1.3,0.5l0.4-0.4c0.3-0.3,0.7-0.3,0.9,0l1.2,1.2c0.3,0.3,0.3,0.7,0,0.9l-0.4,0.4 c0.2,0.4,0.4,0.8,0.5,1.3H16.6z M10.5,18.3c1.6,0,3-1.3,3-3c0-1.6-1.3-3-3-3c-1.6,0-3,1.3-3,3C7.6,17,8.9,18.3,10.5,18.3z M18.1,4.7 l0.2,1.1c0,0.2-0.1,0.4-0.3,0.4l-0.5,0.1c-0.1,0.4-0.2,0.8-0.4,1.1l0.3,0.4c0.1,0.2,0.1,0.4-0.1,0.5l-0.8,0.7 c-0.1,0.1-0.4,0.1-0.5,0l-0.4-0.4c-0.4,0.1-0.8,0.2-1.2,0.2L14,9.3c-0.1,0.2-0.3,0.3-0.5,0.2l-1-0.4c-0.2-0.1-0.3-0.3-0.2-0.5 l0.1-0.5C12.3,8,12.1,7.8,12,7.7c-0.1-0.2-0.2-0.3-0.3-0.5l-0.5,0c-0.2,0-0.4-0.1-0.4-0.3l-0.2-1.1c0-0.2,0.1-0.4,0.3-0.4l0.5-0.1 c0.1-0.4,0.2-0.8,0.4-1.1l-0.3-0.4c-0.1-0.2-0.1-0.4,0.1-0.5l0.8-0.7c0.1-0.1,0.4-0.1,0.5,0l0.4,0.4c0.4-0.1,0.8-0.2,1.2-0.2 l0.2-0.5C14.9,2,15.1,2,15.3,2l1,0.4c0.2,0.1,0.3,0.3,0.2,0.5l-0.1,0.5c0.1,0.1,0.3,0.3,0.4,0.4C16.9,4,17,4.2,17.1,4.4l0.5,0 C17.9,4.3,18,4.5,18.1,4.7z M15.4,7.1c0.7-0.6,0.9-1.7,0.3-2.4c-0.6-0.7-1.6-0.9-2.4-0.3c-0.7,0.6-0.9,1.6-0.3,2.4 C13.6,7.6,14.7,7.7,15.4,7.1z",
  fill: color
}));

const Document = exports.Document = createIconSvg("Document", ({ color }) => _react2.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm1 14H8c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1zm3-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
  fill: color
}));

const Download = exports.Download = createIconSvg("Download", ({ color }) => _react2.default.createElement("path", {
  d: "M16.6,10H15V5c0-0.6-0.4-1-1-1h-4C9.4,4,9,4.4,9,5v5H7.4c-0.9,0-1.3,1.1-0.7,1.7l4.6,4.6c0.4,0.4,1,0.4,1.4,0l4.6-4.6 C17.9,11.1,17.5,10,16.6,10z M5,20c0,0.5,0.4,1,1,1h12c0.5,0,1-0.5,1-1s-0.5-1-1-1H6C5.4,19,5,19.5,5,20z",
  fill: color
}));

const Minus = exports.Minus = createIconSvg("Minus", ({ color }) => _react2.default.createElement("path", {
  d: "M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  fill: color
}));